import { Component } from '@angular/core';

@Component({
  selector: 'app-wifi-link',
  templateUrl: './wifi-link.component.html',
  styleUrls: ['./wifi-link.component.scss']
})
export class WifiLinkComponent {

}
